module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Files/Upload-34394dc1ad04efd311505ef417cf40d4d8d88023ebaf532ba5cba4cf5bf45a3d.svg";